import { Helmet } from 'react-helmet'
import { TabMenu } from '../../../components/BaseComponents'
import PageHeadings from '../../../components/BaseComponents/PageHeadings/PageHeadings'
import PageTemplate from '../../../components/BaseComponents/PageTemplate/PageTemplate'
import { routes } from '../../../components/Router/routes'
import CompanyInsightsCarbonAccounts from './CarbonAccounts'
import CompanyInsightsSupplyChain from './SupplyChainDecarbonisation'

const CompanyInsightsPeriodicReportsPage = () => {
	return (
		<>
			<PageTemplate testid='company-dashboard-main'>
				<Helmet>
					<title>{routes.companyInsightsPeriodicReports.name}</title>
				</Helmet>
				<PageHeadings crumbs={[{ label: 'Periodic Reports' }]} />

				<TabMenu
					ariaLabel='Periodic reports'
					additionalClass='mt-8'
					tabs={[
						{
							id: 'carbon-accounts',
							label: 'Carbon Accounts',
							panel: () => (
								<CompanyInsightsCarbonAccounts />
							),
						},
						{
							id: 'supply-chain',
							label: 'Supply Chain Decarbonisation',
							panel: () => (
								<>
									{/* <p className='text-white p-4'>
										<span className='text-algae-300'>Coming soon:</span> compare sectors and suppliers
										for carbon intensity ratio
									</p> */}
									<CompanyInsightsSupplyChain />
								</>
							),
						},
					]}
				/>
			</PageTemplate>
		</>
	)
}
export default CompanyInsightsPeriodicReportsPage
